<template>
  <base-modal ref="modal" @hiding="reset">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Send Sample SMS</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-phone-number-input label="Mobile Phone" v-model="phone" :e164.sync="phone164" required />
      </base-form>
      <inline-error class="tw-my-3" id="add-user-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4 sm:tw-mt-0">
        <base-button @click="send" :loading="isSending" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Send</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>
<script>
import InlineError from "@/components/InlineError";

export default {
  name: "SampleSmsModal",
  components: { InlineError },
  data() {
    return {
      businessId: null,
      template: null,
      isSending: false,
      isFormValid: true,
      phone: "",
      phone164: "",
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    show(businessId, template) {
      this.businessId = businessId;
      this.template = template;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    send() {
      if (!this.$refs.form.validate()) return;
      this.isSending = true;

      this.$axios
        .post(`/admin/email/templates/${this.template}/business/${this.businessId}/send-sms`, { phone: this.phone164 })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "SMS Sent", message: "SMS was sent successfully" });
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error sending SMS`;
          this.errorMessage = "Sorry, we had trouble sending the sms. Please check logs in the console and try again.";
          this.error = err;
        })
        .finally(() => {
          this.isSending = false;
        });
    },
    reset() {
      this.phone = null;
      this.template = null;
      this.businessId = null;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
  },
};
</script>
